import React from "react";
import { Link } from "react-router-dom";
import PrivacyAssuranceLink from "./PrivacyAssuranceLink";

export default function Footer() {
  return (
    <footer className="bg-[#f2ecdc] border-t border-[#e6dcc6] pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-[auto_1fr_1fr] gap-12 mb-12">
          <div>
            <Link to="/" className="flex items-center gap-1">
              <span className="font-display text-[22px] font-semibold tracking-tight text-[#0f1724]">
                ascend
              </span>
              <span className="font-display text-[22px] font-semibold tracking-tight text-[#486a8f]">
                higher
              </span>
            </Link>
            <p className="font-body text-[13px] text-[#6b7280] mt-4 max-w-xs">
              Your AI life coach that remembers you. Built for daily clarity.
            </p>
          </div>

          <div className="flex flex-wrap gap-8 md:justify-end">
            <div>
              <p className="font-mono-eyebrow text-[#6b7280] mb-4">Product</p>
              <ul className="space-y-2.5">
                <li><a href="#how-it-works" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors">How it works</a></li>
                <li><a href="#pillars" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors">5 Pillars</a></li>
                <li><Link to="/challenge" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors">7-Day Challenge</Link></li>
                <li><Link to="/beta" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors">Become a beta tester</Link></li>
                <li><a href="#pricing" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors">Pricing</a></li>
                <li><Link to="/faq" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors">FAQ</Link></li>
              </ul>
            </div>
            <div>
              <p className="font-mono-eyebrow text-[#6b7280] mb-4">Company</p>
              <ul className="space-y-2.5">
                <li><a href="#about" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors">About</a></li>
                <li><Link to="/privacy-promise" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors">Privacy Promise</Link></li>
                <li><Link to="/privacy" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors">Privacy Policy</Link></li>
                <li><Link to="/terms" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors">Terms</Link></li>
                <li><Link to="/refund" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors">Refunds</Link></li>
                <li><Link to="/support" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors">Support & FAQ</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-[#e6dcc6] flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
          <div className="flex flex-col gap-2">
            <p className="font-body text-[12px] text-[#6b7280]">
              © 2026 Ascendapp LLC — All rights reserved
            </p>
            <PrivacyAssuranceLink />
          </div>
          <p className="font-body text-[12px] text-[#6b7280] max-w-2xl md:text-right">
            Ascend Higher is a personal growth and organization tool. It is not therapy,
            medical care, diagnosis, treatment, or crisis support. If you are in crisis,
            please call or text{" "}
            <a href="tel:988" className="text-[#486a8f] font-medium hover:underline">988</a>.
          </p>
        </div>
      </div>
    </footer>
  );
}
